// extracted by mini-css-extract-plugin
export default {"innerWrapper":"cw-z","tooltipWrapper":"dw-z","icon":"ew-z","tooltip":"fw-z","content":"gw-z"};